import BigScreenWebPage from "../../../unreal/BigScreenWebPage";
import {useVscContext} from "../../content/VscReactContext";


export interface ICommunityMapProps {
    lotId?: string;
    viewBox?: [number, number, number, number]
}

export function BigScreenCommunityMap(props: ICommunityMapProps) {
    const vscContext = useVscContext();

    const { lotId } = props;
    let url = "/vsc/?root=" + encodeURIComponent(vscContext.getVisualizerControllerUri(''))
    if (props.viewBox) {
        url += `&viewBox=${props.viewBox.join("%20")}`;
    }

    if (lotId) {
        url += "#" + lotId;
    }

    return <BigScreenWebPage uri={vscContext.getVisualizerControllerUri(url)} />

}